module.exports = __webpack_public_path__ + "media/images/menu/eclipses-b3fd0bd8b95e76e089b30e3113c59fed.jpg";